export default __webpack_public_path__ + "static/media/pen.a308c3de.svg";